export const UPSC_CURRENT_AFFAIRS_PATH_PREFIX = '/upsc-current-affairs';

export const UPSC_CURRENT_AFFAIRS_HEADER_TITLE = 'UPSC Current Affairs';

export const isUpscCurrentAffairsRoute = (pathname = '') =>
  pathname.startsWith(UPSC_CURRENT_AFFAIRS_PATH_PREFIX);

export const UPSC_MAIN_HEADER_OFFSET = {
  desktop: '72px',
  mobile: '48px'
};

export const UPSC_SUB_NAV_HEIGHT = {
  desktop: '48px',
  mobile: '40px'
};

export const UPSC_STICKY_SIDE_TOP = {
  desktop: '120px',
  mobile: '88px'
};

export const UPSC_STICKY_SCROLL_MARGIN = {
  desktop: '136px',
  mobile: '104px'
};

export const UPSC_NAV_TABS = [
  {
    id: 'upsc_nav_home',
    label: 'Home',
    path: '/upsc-current-affairs/home'
  },
  {
    id: 'upsc_nav_todays_analysis',
    label: "Today's Analysis",
    path: '/upsc-current-affairs/today-analysis'
  },
  {
    id: 'upsc_nav_quiz',
    label: 'Quiz',
    path: '/upsc-current-affairs/quiz'
  },
  {
    id: 'upsc_nav_calendar',
    label: 'Calendar',
    path: '/upsc-current-affairs/calendar'
  },
  {
    id: 'upsc_nav_monthly_pdf',
    label: 'Monthly PDF',
    path: '/upsc-current-affairs/monthly-pdf'
  },
  {
    id: 'upsc_nav_subject_wise',
    label: 'Subject wise',
    path: '/upsc-current-affairs/subject-wise'
  }
];

export const getUpscNavTabIndexFromPathname = (pathname = '') => {
  const index = UPSC_NAV_TABS.findIndex((tab) => tab.path === pathname);
  return index >= 0 ? index : 0;
};
